import React, { forwardRef } from "react";
import styled from "styled-components";
import { styleTheme } from "../../../style/theme";

import { TextAreaPropsType } from "./TextArea.types";

const Component = forwardRef<HTMLTextAreaElement, TextAreaPropsType>(
  ({ ...props }, ref) => (
    <textarea className={props.className} {...props} ref={ref} />
  )
);

export const TextArea: React.FC<TextAreaPropsType> = styled(Component)`
  background: ${styleTheme.colors.white};
  border: 1px solid ${styleTheme.colors.gray.base};
  border-radius: 6px;
  color: ${styleTheme.colors.black};
  font-size: 16px;
  height: auto;
  padding: 14px 16px;
  resize: none;
  width: calc(100% - 28px);

  &:hover {
    border: 1px solid ${styleTheme.colors.teal.base};
  }

  &:focus {
    border: 1px solid ${styleTheme.colors.teal.base};
    outline: 1px solid ${styleTheme.colors.teal.base};
  }

  &::placeholder {
    color: ${styleTheme.colors.gray.base};
  }
`;
